import { c as _c } from "react/compiler-runtime";
import type { DocumentUpload } from '@onefootprint/request-types/dashboard';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type useEntityVault from '@/entities/hooks/use-entity-vault';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import { type Rotation, rotateClockwise } from '@/utils/rotation';
import { getUploadKey } from '../../utils/get-doc-upload-key';
import DetailsLayoutWrapper from '../details-layout-wrapper';
import DrawerContent from '../drawer-content';
import UploadImageItem from '../upload-image-item';
export type DecryptedCustomDocumentContentProps = {
  document: TransformedDocument;
  vault: ReturnType<typeof useEntityVault>;
  upload: (DocumentUpload & {
    isLatest: boolean;
  }) | undefined;
};
const DecryptedCustomDocumentContent = t0 => {
  const $ = _c(28);
  const {
    document,
    vault,
    upload
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [rotations, setRotations] = useState(t2);
  let t3;
  if ($[2] !== vault.data?.vault) {
    t3 = vault.data?.vault || {};
    $[2] = vault.data?.vault;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const vaultData = t3;
  let t4;
  if ($[4] !== upload) {
    t4 = upload ? getUploadKey(upload) : "missing-upload";
    $[4] = upload;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const uploadKey = t4;
  let t5;
  if ($[6] !== uploadKey) {
    t5 = () => {
      setRotations(prev => ({
        ...prev,
        [uploadKey]: rotateClockwise(prev[uploadKey] ?? 0)
      }));
    };
    $[6] = uploadKey;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const rotateUpload = t5;
  let t6;
  if ($[8] !== document || $[9] !== vault) {
    t6 = <DrawerContent document={document} vault={vault} />;
    $[8] = document;
    $[9] = vault;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0
    };
    t8 = {
      opacity: 1
    };
    t9 = {
      opacity: 0
    };
    t10 = {
      duration: 0.15
    };
    $[11] = t10;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] !== rotateUpload || $[16] !== rotations || $[17] !== t || $[18] !== upload || $[19] !== uploadKey || $[20] !== vaultData) {
    t11 = upload ? <UploadImageItem upload={upload} vault={vaultData} rotation={rotations[uploadKey] ?? 0} onRotate={rotateUpload} /> : <div className="text-label-2 text-primary">{t(_temp)}</div>;
    $[15] = rotateUpload;
    $[16] = rotations;
    $[17] = t;
    $[18] = upload;
    $[19] = uploadKey;
    $[20] = vaultData;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== uploadKey) {
    t12 = <div className="flex flex-col items-center gap-8 w-full md:w-[70%] h-full"><AnimatePresence mode="wait" initial={false}><motion.div key={uploadKey} initial={t7} animate={t8} exit={t9} transition={t10} className="w-full">{t11}</motion.div></AnimatePresence></div>;
    $[22] = t11;
    $[23] = uploadKey;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6) {
    t13 = <DetailsLayoutWrapper drawerChildren={t6}>{t12}</DetailsLayoutWrapper>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
export default DecryptedCustomDocumentContent;
function _temp($) {
  return $.customDocumentError;
}